import React from 'react';

const LogoMark = ({ className = '' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="32" height="32" rx="9" fill="#141410" />
    <rect x="10.5" y="10.5" width="11" height="11" rx="3.5" fill="#FFFFFF" />
    <circle cx="16" cy="6.75" r="2.4" fill="#BCD445" />
    <circle cx="16" cy="25.25" r="2.4" fill="#BCD445" />
    <circle cx="6.75" cy="16" r="2.4" fill="#BCD445" />
    <circle cx="25.25" cy="16" r="2.4" fill="#BCD445" />
  </svg>
);

export default LogoMark;
